import type { ParseKeys, TFunction } from 'i18next';

export const optionValues = (values: Record<string, string>, t: TFunction<'de'>, keyPrefix: string) =>
    Object.values(values).map((value) => ({
        label: t(`${keyPrefix}.${value}` as ParseKeys<'de'>),
        value,
    }));

export const optionValuesWithLast = (
    values: Record<string, string>,
    lastValue: string,
    t: TFunction<'de'>,
    keyPrefix: string,
) => {
    const options = optionValues(values, t, keyPrefix);
    return [
        ...options.filter(({ value }) => value !== lastValue),
        ...options.filter(({ value }) => value === lastValue),
    ];
};
